/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    countrySelector: {
      height: 50,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    option: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    countryIcon: {
      height: 20,
    },
    countryLabel: {
      fontSize: 14,
      fontWeight: 400,
      margin: '0 5px',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
